import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'auth','shop','alert'
    ],  // localStorageに保存したいstoreを入れる
  })(store);
};